import { render } from "./PaymentMethodListWarning.vue?vue&type=template&id=46df0ee2"
import script from "./PaymentMethodListWarning.vue?vue&type=script&lang=js"
export * from "./PaymentMethodListWarning.vue?vue&type=script&lang=js"

import "./PaymentMethodListWarning.vue?vue&type=style&index=0&id=46df0ee2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__